import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import type { PackageReorder, PackageResponse } from "./packagesApi";
import { listPackages, reorderPackages } from "./packagesApi";

const EMPTY_PACKAGES: PackageResponse[] = [];

export const usePackages = () => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  const { data, isLoading } = useQuery({
    queryKey: ["packages"],
    queryFn: ({ signal }) => listPackages(signal),
  });

  const reorderMutation = useMutation({
    mutationFn: (reorders: PackageReorder[]) => reorderPackages(reorders),
    onSuccess: () => {
      enqueueSnackbar(`Kolejność pakietów została zaktualizowana`, { variant: "success" });
      queryClient.invalidateQueries({ queryKey: ["packages"] });
    },
    onError: (error) => {
      enqueueSnackbar(`Nie udało się zaktualizować kolejności pakietów. Powód: ${(error as Error).message}`, {
        variant: "error",
      });
    },
  });

  return {
    packages: data ?? EMPTY_PACKAGES,
    isLoading,
    reorderPackages: reorderMutation.mutateAsync,
    isReorderPending: reorderMutation.isPending,
  };
};
